import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FormGroup } from '@patternfly/react-core';
import { useCallback, useMemo } from 'react';
import { SimpleSelector } from '../../Typeahead/SimpleSelector';
import { Typeahead } from '../../Typeahead/Typeahead';
import { isDefined } from '../../utils';
export const SchemaList = ({ propName, selectedSchema, schemas, onChange, onCleanInput, placeholder, 'aria-label': ariaLabel, 'data-testid': dataTestId, children, }) => {
    const items = useMemo(() => schemas.map(({ name, description, schema }) => ({ name, description, value: schema })), [schemas]);
    const useTypeahead = items.length > 5;
    const selectedItem = useMemo(() => {
        if (!selectedSchema) {
            return undefined;
        }
        return items.find((item) => item.name === selectedSchema.name);
    }, [items, selectedSchema]);
    const onItemChange = useCallback((item) => {
        if (!isDefined(item)) {
            onChange(undefined);
            return;
        }
        onChange({
            name: item.name,
            description: item.description,
            schema: item.value,
        });
    }, [onChange]);
    return (_jsxs(_Fragment, { children: [_jsx(FormGroup, { isStack: true, hasNoPaddingTop: true, fieldId: propName, role: "group", children: useTypeahead ? (_jsx(Typeahead, { "aria-label": ariaLabel, "data-testid": dataTestId, selectedItem: selectedItem, items: items, id: propName, placeholder: placeholder, onChange: onItemChange, onCleanInput: onCleanInput })) : (_jsx(SimpleSelector, { "aria-label": ariaLabel, "data-testid": dataTestId, selectedItem: selectedItem, items: items, id: propName, onChange: onItemChange })) }), children] }));
};
//# sourceMappingURL=SchemaList.js.map